
import GalleryTick from "../../../assets/duotone/GalleryTick.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function GalleryTickIcon({ className, dataTestid = "GalleryTickIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <GalleryTick data-testid={dataTestid} className={classes} {...rest} />
  );
}
